import React from 'react';
import { Bar } from 'react-chartjs-2';
import _ from 'lodash';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { QCard } from '../../Q-Components/QCard';
import { QCardHeader } from '../../Q-Components/QCardHeader';
import { QCardBody } from '../../Q-Components/QCardBody';
import { QTypography } from '../../Q-Components/QTypography';

export const getRiskCounts = results => {
  try {
    const labels = _.uniq(results.map(result => result.ruleId.split('/')[1]));

    const riskCounts = {
      warning: Array(labels.length).fill(0),
      note: Array(labels.length).fill(0),
      error: Array(labels.length).fill(0),
      labels,
    };

    results.forEach(result => {
      const label = result.ruleId.split('/')[1];
      const labelIndex = riskCounts.labels.indexOf(label);

      if (labelIndex !== -1) {
        if (result.risk in riskCounts) {
          riskCounts[result.risk][labelIndex]++;
        }
      }
    });

    return riskCounts;
  } catch (error) {
    console.error('Error getting risk counts', error);
    return {
      warning: [],
      note: [],
      error: [],
      labels: [],
    };
  }
};

export const ProfileCategoriesBarChart = ({ title, results, options }) => {
  const { mastV2 } = useFlags();
  const BORDER_RADIUS = 15;
  const BAR_WIDTH_PERCENTAGE = 0.3;
  const ERROR_COLOR = '#F44336';
  const WARNING_COLOR = '#FF9800';
  const NOTE_COLOR = '#2196F3';

  const riskCounts = getRiskCounts(results);

  const data = {
    labels: riskCounts.labels,
    datasets: [
      {
        label: 'Error',
        data: riskCounts.error,
        backgroundColor: ERROR_COLOR,
        borderColor: ERROR_COLOR,
        hoverBackgroundColor: ERROR_COLOR,
        borderRadius: BORDER_RADIUS,
        barPercentage: BAR_WIDTH_PERCENTAGE,
      },
      {
        label: 'Warning',
        data: riskCounts.warning,
        backgroundColor: WARNING_COLOR,
        borderColor: WARNING_COLOR,
        hoverBackgroundColor: WARNING_COLOR,
        borderRadius: BORDER_RADIUS,
        barPercentage: BAR_WIDTH_PERCENTAGE,
      },
      {
        label: 'Note',
        data: riskCounts.note,
        backgroundColor: NOTE_COLOR,
        borderColor: NOTE_COLOR,
        hoverBackgroundColor: NOTE_COLOR,
        borderRadius: BORDER_RADIUS,
        barPercentage: BAR_WIDTH_PERCENTAGE,
      },
    ],
  };

  const barProps = {
    data,
    options: {
      ...options,
      scales: {
        x: {
          gridLines: {
            display: false,
          },
          stacked: true,
          ticks: {
            autoSkip: false,
          },
        },
        y: {
          gridLines: {
            display: false,
          },
          stacked: true,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  };

  return (
    <QCard style={{ height: '100%' }}>
      <QCardBody>
        <QCardHeader
          tag="h4"
          title={<QTypography variant="h5Medium">{title}</QTypography>}
          style={mastV2 ? {} : { backgroundColor: '#FFFFFF' }}
        >
          {title}
        </QCardHeader>
        <Bar {...barProps} />
      </QCardBody>
    </QCard>
  );
};
